import { State } from 'vuex-class'
import { Component, Vue } from 'vue-property-decorator'
import {
  IFirebaseUserClaim,
  CompanyTypeEnum,
  UserRoleEnum,
  IUserCompany,
  Company,
  AdminRoleEnum
} from '@/firestore'

@Component
export default class AuthMixin extends Vue {
  @State('userClaim')
  public userClaim!: IFirebaseUserClaim

  @State('user')
  public user!: firebase.User

  @State('userCompany')
  public userCompany!: IUserCompany

  @State('companies')
  public companies!: { [companyId: string]: Company }

  get isApplicationAdmin() {
    return this.userClaim
      && this.userClaim.admin
      && this.userClaim.admin === AdminRoleEnum.APPLICATION_ADMIN
  }

  get isReadOnlyAdmin() {
    return this.userClaim
      && this.userClaim.admin
      && this.userClaim.admin === AdminRoleEnum.READ_ONLY_ADMIN
  }

  get isAdmin() {
    return this.userClaim
      && this.userCompany
      && this.userCompany.type === CompanyTypeEnum.ADMIN
  }

  get isAdminForRestaurant() {
    return this.isApplicationAdmin
      || this.userClaim
      && this.userCompany
      && (
        this.userCompany.type === CompanyTypeEnum.ADMIN
        || (
          this.companies
          && this.userCompany.adminCompanyId
          && this.companies[this.userCompany.adminCompanyId]
        )
      )
  }

  get isAdminRole() {
    return this.userClaim
      && this.userCompany
      && this.userCompany.type === CompanyTypeEnum.ADMIN
  }

  get isVendor() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.type === CompanyTypeEnum.VENDOR
      )
      || this.isAdmin
    )
  }

  get isRestaurant() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.type === CompanyTypeEnum.RESTAURANT
      )
      || this.isAdmin
    )
  }

  get isSuperUser() {
    return this.isAdmin
      && this.isAdminRole
  }

  get isGeneralManager() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.userRole === UserRoleEnum.GENERAL_MANAGER
      )
      || this.isAdmin
    )
  }

  get isChef() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.userRole === UserRoleEnum.CHEF
      )
      || this.isAdmin
    )
  }

  get isManager() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.userRole === UserRoleEnum.MANAGER
      )
      || this.isAdmin
    )
  }

  get isAccountant() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.userRole === UserRoleEnum.ACCOUNTANT
      )
      || this.isAdmin
    )
  }

  get isUser() {
    return this.userClaim && (
      (
        this.userCompany
        && this.userCompany.userRole === UserRoleEnum.USER
      )
      || this.isAdmin
      || this.isReadOnlyAdmin
    )
  }

  get isGeneralManagerOrGreater() {
    return this.userClaim && (
      (
        this.userCompany
        && (
          this.isGeneralManager
          || this.isChef
        )
      )
      || (
        this.isAdmin
        || this.isAdminForRestaurant
        || this.isAdminRole
      )
    )
  }

  get isChefOrGreater() {
    return this.userClaim && (
      (
        this.userCompany
        && (
          this.isGeneralManager
          || this.isChef
        )
      )
      || (
        this.isAdmin
        || this.isAdminForRestaurant
        || this.isAdminRole
      )
    )
  }

  get isManagerOrGreater() {
    return this.userClaim && (
      (
        this.userCompany
        && (
          this.isManager
          || this.isGeneralManagerOrGreater
        )
      )
      || this.isAdmin
    )
  }

  get isUserOrGreater() {
    return this.userClaim && (
      (
        this.userCompany
        && (
          this.isUser
          || this.isManagerOrGreater
        )
      )
      || this.isAdmin
      || this.isReadOnlyAdmin
    )
  }
}
